import { useLocation, useNavigate } from "react-router-dom";
import NavButton from "./NavButton";
import { LogoutButton } from "./LogoutButton";
import { NAV_ITEMS } from "../../constants/NavItems";

export default function DesktopMenu({ isAdmin, closeMenu }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      id="desktop-menu"
      role="menu"
      className="flex items-center justify-center gap-5 pl-5"
    >
      {isAdmin && (
        <div className="flex flex-row flex-wrap items-center gap-4">
          {NAV_ITEMS.map((item) => (
            <NavButton
              key={item.path}
              label={item.label}
              isActive={location.pathname === item.path}
              onClick={() => {
                navigate(item.path);
                closeMenu();
              }}
              tabIndex={0}
            />
          ))}
        </div>
      )}
      <LogoutButton />
    </div>
  );
}
